import React from 'react';

export default function IndependentStudyModalContent() {
  return (
    <p>
      Beneficiaries may use educational assistance to access online learning
      (accredited independent study) at schools that aren’t Institutions of
      Higher Learning (IHLs). These schools must be postsecondary vocational
      institutions or area career and technical education schools that provide
      postsecondary level education. <strong>Note:</strong> This doesn’t apply
      to Dependents’ Educational Assistance program beneficiaries.
    </p>
  );
}
